import { StopNotesAndReferenceNumbers } from "../StopNotesAndReferenceNumbers";
import { StopShowAsButton } from "../StopShowAsButton";
import { CityState, DataSource, Image, Label, Layout, Location, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRecOrderStop extends Layout {
    citystate: CityState;
    imageYSplitDrop: Image;
    labelAdditionalStopDetails: Label;
    labelCreatingLocation: Label;
    labelPickup: Label;
    layoutStopNotesAndRefNbrs: StopNotesAndReferenceNumbers;
    layoutStopShowAsButton: StopShowAsButton;
    panel1: Panel;
    panelAdditionalDetails: Panel;
    panelMain: Panel;
    panelStopCommentsReferenceNumbers: Panel;
    panelStopFreeForm: Panel;
    sourceStopRecOrder: DataSource;
    switchApptRequired: Switch;
    switchPalletsRequired: Switch;
    textboxAddress2: Textbox;
    textboxAddress: Textbox;
    textboxAppointmentStatusId: Textbox;
    textboxCases: Textbox;
    textboxContactEmail: Textbox;
    textboxContactName: Textbox;
    textboxDriverLoadUnload: Textbox;
    textboxLocationCode: Textbox;
    textboxLocationId: Location;
    textboxLocationName: Textbox;
    textboxPalletsHowMany: Textbox;
    textboxPhone: Textbox;
    textboxStopType: Textbox;
    textboxVolume: Textbox;
    textboxWeight: Textbox;
    textboxZoneId: Textbox;
}
